
import { IUpdateSclaFamily, SclaApplication } from 'features/scla/types';
import { makePutRequest } from 'lib/axios';

const updateSclaAppFamily = async (
  id: string,
  payload: IUpdateSclaFamily,
): Promise<SclaApplication> => {
  const url = `/scla/application/family/${id}`;
  const response = await makePutRequest(url, payload);
  return response.data.payload;
};

export default updateSclaAppFamily;
